export default __webpack_public_path__ + "static/media/schedulingIcon.37db1d95.svg";